// https://www.typescriptlang.org/community
// https://www.typescriptlang.org/ko/community

export const comCopy = {
  com_layout_title: "TypeScript 커뮤니티 페이지",
  com_layout_description:
    "https://www.typescriptlang.org/ko/community 에 표시될 문자열들",

  com_headline: "Connect with us", // FIXME: I think this is not used anywhere
  com_connect_online: "온라인",
  com_connect_online_description:
    "잘 동작하는 것, 원하는 추가 기능 또는 개선 사항을 알려 주세요. 또는 새 업데이트를 찾아보세요.",
  com_online_stack_overflow_desc:
    "'typescript' 태그를 사용하여 다른 사용자와 소통하거나 질문해 보세요.",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "채팅",
  com_online_discord_desc:
    "TypeScript 커뮤니티 채팅에서 다른 사용자와 채팅해 보세요.",
  com_online_github_desc:
    "버그를 찾으셨거나 의견이 있으신가요?",
  com_online_github_href: "GitHub에서 알려주세요",
  com_online_twitter_desc: "트위터에서 최신 정보를 확인하세요. ",
  com_online_blog_desc:
    "TypeScript 최신 개발 상황을 다음에서 확인할 수 있습니다. ", //... blog
  com_online_typed_desc: " ",
  com_online_typed_href: "Definitely Typed 에서 ",
  com_online_typed_available_for:
    "공통 라이브러리와 프레임워크를 위한 수많은 TypeScript 정의 파일을 확인하세요.",
  com_person: "사람들과 만나기",
  com_conferences: "Conferences", // FIXME: I think this is not used anywhere
  com_conferences_alt_img: "logo of ", // FIXME: I think this is not used anywhere
}
